module.exports = __webpack_public_path__ + "img/img-chart-01.887d9bd1.png";